import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/customericon.jpg';
import axios from "axios";
import deleteIcon from '../images/enabledisable.jpeg';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import { data } from "react-router";
const Users=()=>
{
const [show,setShow]=useState(false);
    const [msg,setMsg]=useState("");
    const [userdata,setUserData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({ulogin:"",upassword:"",utype:"",name:"",subscriberid: 0,aadhar:"",pan:"",other:"",facilityid:0,facilityname:""});
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [progress,setProgress]=useState(false);
    const [facilities,setFacilities]=useState([]);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Login", key: "ulogin", sortable: true},
        { name: "Password", key: "upassword", sortable: false },        
        { name: "User Type", key: "utype", sortable: true },
        { name: "Client", key: "owner", sortable: true },
        { name: "Company", key: "company", sortable: true},      
        { name: "Valid", key: "isvalid", sortable: true},        
    ];
    function addSubsriber(event)
    {
        setFormData({ulogin:"",upassword:"",utype:"",name:"",subscriberid: 0,aadhar:"",pan:"",other:"",facilityid:0,facilityname:""});
        setShow(true);
        setMsg("");
    }
    async function saveData(event)
    {
         let obj=userdata.find((e)=>e.ulogin==formData.ulogin);
         if(!obj)
         {
            if(formData.ulogin.length<6)
            {
                setMsg("User Name length is Min 6!!!!");
                return;
            }
            if(formData.upassword.length<8)
            {
                setMsg("Min. Password length is 8!!!!");
                return;
            }
            if(formData.utype=="" || formData.utype=="none" )
            {
                setMsg("Select User Type!!!!");
                return;
            }
            if(formData.name.length<3 )
            {
                setMsg("Please Enter Valid User Name!!!!");
                return;
            }
            if(window.confirm('Are you sure?'))
            {                
                setProgress(true);
                await apiClient.post("/api/User/CreateUser",formData).then(reply=>
                {
                    if(reply.status==200)
                    {
                        if(reply.data.status=="Error")
                        {
                            setMsg(reply.data.message);                        
                        }
                        else if(reply.data.status=="OK")
                        {
                            loadData();
                            alert("User Created Successfully");
                            setFormData({ulogin:"",upassword:"",utype:"",name:"",subscriberid: 0,aadhar:"",pan:"",other:"",facilityid:0,facilityname:""});
                            setShow(false);                        
                        }
                        else
                        {
                            setMsg("Unknown Error!!!");                        
                        }
                    }
                });   
                setProgress(false);
            }
         }
         else if(window.confirm("Would You Like to Update the Password"))
         {
            if(formData.upassword.length<8)
            {
                setMsg("Min. Password length is 8!!!!");
                return;
            }
            obj.upassword=formData.upassword;
            setProgress(true);
            await apiClient.post("/api/User/UpdateUser",obj).then(reply=>
            {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadData();
                        alert("Password Updated Successfully");
                        setFormData({ulogin:"",upassword:"",utype:"",name:"",subscriberid: 0,aadhar:"",pan:"",other:"",facilityid:0,facilityname:""});
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
            });   
            setProgress(false);
         }

        
        
    }
    async function loadData()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/User/GetAllUsers").then(res=>
        {
            if(res.status==200)
            {
                setUserData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));                
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });  
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200)
            {
                setFacilities(res.data.data);                
            }
        });     
        setProgress(false);   
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=userdata.filter((e)=>e.company.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.ulogin.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  || e.owner.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(userdata);                
                setPageData(userdata.slice(0,pageSize));
            }
            setPage(1);
        }            
    }    
    async function enableDisableUser(ulogin)
    {
        let obj=userdata.find((e)=>e.ulogin==ulogin);
        if(obj)
        {
            if(window.confirm('Would you like to Change the Status?\nAre you sure?'))
            {
                
                setProgress(true);    
                await apiClient.post(process.env.REACT_APP_APIURL+"/api/User/EnableDisableUser/"+ulogin).then(res=>
                    {
                        if(res.status==200)
                        {
                            alert(res.data.message);
                            loadData();                    
                        }
                    });
                setProgress(false);
                
            }
        }
    }    
    function editUser(ulogin)
    {
        let obj=userdata.find((e)=>e.ulogin==ulogin);
        if(obj)
        {
            setFormData({...obj});
            setShow(true);
        }
    }
    function sortData(colname)
    {
        if(colname=="ulogin" || colname=="utype" || colname=="owner" || colname=="company" || colname=="isvalid")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }            
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadData();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control" /></div>                
                <div className="flex-grow-1 text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addSubsriber} /></div>
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>User Details</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}
                            <th>View/Edit</th>
                            <th>Enable/Disable</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>                            
                                    ee.key=="upassword"?(<td>**** **** ****</td>):(<td>{e[ee.key]}</td>)                            
                                )}
                                <td className="text-center"><img onClick={()=>editUser(e.ulogin)} src={editIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>enableDisableUser(e.ulogin)} src={deleteIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="1"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="7" className="text-center"></th>
                            <th colSpan="1" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="9">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                        
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Users</div>
                                        <div className="row">
                                            <div className="form-group">
                                                <label>User Name:</label>
                                                <input type="text" className="form-control" value={formData.ulogin} onChange={(event)=>{setFormData({...formData,ulogin:event.target.value})}} />
                                            </div>
                                            <div className="form-group">
                                                <label>Password:</label>
                                                <input type="password" className="form-control" value={formData.upassword} onChange={(event)=>{setFormData({...formData,upassword:event.target.value})}} />
                                            </div>
                                            <div className="form-group">
                                                <label>User Type:</label>
                                                <select className="form-control" onChange={(event)=>{setFormData({...formData,utype:event.target.value})}}>
                                                    <option value="none">Select User Type</option>
                                                    <option value="admin" selected={formData.utype=="admin"}>Admin</option>
                                                    <option value="staff" selected={formData.utype=="staff"}>Staff</option>                                                    
                                                    <option value="franchisee" selected={formData.utype=="franchisee"}>Franchisee</option>
                                                    <option value="subscriber" selected={formData.utype=="subscriber"}>Subscriber</option>
                                                </select>                                                
                                            </div>
                                            {(formData.utype=="franchisee" || formData.utype=="staff") && (<div>
                                                <label>Facility</label>
                                                <select className="form-control" onChange={(event)=>setFormData({...formData,facilityid:event.value})}>
                                                    <option value="0">Head Office</option>
                                                    {facilities.map((e,i)=><option key={i} value={e.id}>{e.facilityname}</option>)}
                                                </select>
                                            </div>)}
                                            <div className="form-group">
                                                <label>Full Name:</label>
                                                <input type="text" className="form-control" value={formData.name} onChange={(event)=>{setFormData({...formData,name:event.target.value})}} />
                                            </div>                                            
                                        </div>
                                    <input type="button" className="btn btn-danger mt-2"  onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default Users;